import { fontSize, lineHeight } from "@stereoagency/tailwind-config";
import { extendTailwindMerge } from "tailwind-merge";
export var twMerge = extendTailwindMerge({
    classGroups: {
        "font-size": [
            {
                text: Object.keys(fontSize)
            }
        ],
        "line-height": [
            {
                leading: Object.keys(lineHeight)
            }
        ]
    }
});

//# sourceMappingURL=twMerge.js.map